// src/App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { UserProvider } from './contexts/UserContext'; // Import UserProvider from context.js

import HomePage from './Pages/Homepage';
import LoginModal from './Components/Login';
import Dashboard from './Pages/Dashboard';
import Admindashboard from './Pages/Admindashboard';
import OrderList from './Components/OrderList';
import OrderPlaced from './Components/OrderPlaced';
import ProfileV2 from './Components/ProfileV2';
import HennaBooking from './Components/hennabooking';

const App = () => {
  return (
    <UserProvider>
      <Router>
        <Routes>
          <Route path="/*" element={<HomePage />} />
          <Route path="/Login" element={<LoginModal isOpen toggleModal={() => {}} />} />
          <Route path="/Dashboard" element={<Dashboard />} />
          <Route path="/Admindashboard" element={<Admindashboard />} />
          <Route path="/AdminDashboard" element={<Admindashboard />} />
          <Route path="/OrderList" element={<OrderList />} />
          <Route path="/OrderPlaced" element={<OrderPlaced />} />
          <Route path="/ProfileV2" element={<ProfileV2 />} />
          <Route path="/henna-booking" element={<HennaBooking />} />
        </Routes>
      </Router>
    </UserProvider>
    
  );
};

export default App;